import { useState } from "react";
import { ExportDataButton } from "common/components/ExportDataButton";
import ExportToCSV from "../../exportToCSV";

export const ExportButton = ({
  clientId,
  jobIds,
  jobStatus,
  disabled,
  getParams,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const onSuccess = () => {
    setOpen(false);
    props.onSuccess?.();
  };

  return (
    <>
      <ExportDataButton disabled={disabled} onClick={() => setOpen(true)} />

      {open && (
        <ExportToCSV
          open={open}
          jobIds={jobIds}
          clientId={clientId}
          jobStatus={jobStatus}
          onSuccess={onSuccess}
          onCancel={() => setOpen(false)}
          getParams={getParams}
        />
      )}
    </>
  );
};
